import { apiConstants } from './api-constants';
let code = apiConstants.code;

export const EVENTS = {
    INITIALIZE_NEW_FEATURE: 'map.new-feature-initialize',
    FINISHED_NEW_FEATURE: 'map.new-feature-finished',
    SHOW_MODAL_NEW_FEATURE: `${code}:new-feature-show-modal`,
    URBANPROCESS_MODAL_DETAIL_SHOW: `${code}:urbanprocess-detail-show-modal`,
    URBANPROCESS_MODAL_DETAIL_CLOSE: `${code}:urbanprocess-detail-close-modal`,
    URBANPROCESS_MODAL_EDIT_SHOW: `${code}:urbanprocess-edit-show-modal`,
    URBANPROCESS_MODAL_EDIT_CLOSE: `${code}:urbanprocess-edit-close-modal`,
    URBANPROCESS_MODAL_CREATE_SHOW: `${code}:urbanprocess-create-show-modal`,
    URBANPROCESS_MODAL_CREATE_CLOSE: `${code}:urbanprocess-create-close-modal`,
    URBANPROCESS_EDIT_GEOMETRY_AREA: `${code}:urbanprocess-edit-area`,
    URBANPROCESS_ASSOCIATE_AREA: `${code}:urbanprocess-associate-area`,
    URBANPROCESS_UPDATED: `${code}:urbanprocess-updated`,
    URBANPROCESS_CONFRONTATIONS_MODAL_SHOW: `${code}:urbanprocess-confrontations-show-modal`,
    URBANPROCESS_ASSOCIATE_AREA_MODAL_SHOW: `${code}:urbanprocess-associate-area-show-modal`,
    URBANAREA_MODAL_DETAIL_SHOW: `${code}:urbanarea-detail-show-modal`,
    URBANAREA_MODAL_DETAIL_CLOSE: `${code}:urbanarea-detail-close-modal`,
    URBANAREA_MODAL_EDIT_SHOW: `${code}:urbanarea-edit-show-modal`,
    URBANAREA_MODAL_EDIT_CLOSE: `${code}:urbanarea-edit-close-modal`,
    URBANAREA_UPDATED: `${code}:urbanarea-updated`,
    URBANAREA_DELETED: `${code}:urbanarea-deleted`,
    URBANAREA_DISASSOCIATE_PROCESS: `${code}:urbanarea-disassociate-process`,
    URBANAREA_ASSOCIATE_PROCESS: `${code}:urbanarea-associate-process`,
    URBANAREA_ASSOCIATE_PROCESS_MODAL_SHOW: `${code}:urbanarea-associate-process-show-modal`,
};

export const MAP_ACTIONS = Object.freeze({
    URBANPROCESS_EDIT_GEOMETRY_AREA: `${code}:urbanprocess-edit-area`,
    URBANPROCESS_ASSOCIATE_AREA: `${code}:urbanprocess-associate-area`,
    URBANPROCESS_ASSOCIATE_PROCESS: `${code}:urbanprocess-associate-process`,
    URBANPROCESS_LINK_AREA: `${code}:urbanprocess-link-area`,
    URBANPROCESS_UNLINK_AREA: `${code}:urbanprocess-unlink-area`
});

export const PROVIDER = Object.freeze({
    DATABASE: 'database',
    AIRC: 'airc',
});

export const URBAN_PROCESS_TABS = Object.freeze({
    GENERAL: 'general',
    TECHNICAL_INFORMATIONS: 'technical_informations',
    ENTITIES: 'entities',
    CONSERVATORY: 'conservatory',
    FINANCES: 'finances',
    DOCUMENTS: 'documents',
    REQUIREMENTS: 'requirements',
    INSPECTIONS: 'inspections',
    SURROUNDING_SPACE_ANALYSIS: 'surrounding_space_analysis',
});

export const URBAN_PROCESS_FIELDS = Object.freeze({
    PROCESS: 'process',
    CLASSIFICATION: 'classification_type_id',
    CONSTRUCTION: 'construction_type_id',
    STATUS: 'status_id',
    SUBJECT: 'subject',
    ADDRESS: 'address',
    DATE: 'entry_at',
    OWNER: 'owner',
});

export const URBAN_PROCESS_SEARCH_FIELDS = Object.freeze({
    PROCESS: 'process',
    SUBJECT: 'subject',
    DICOFRE: 'dicofre',
    ADDRESS: 'address',
    CLASSIFICATION: 'classification_type',
    REGIME: 'regime_type',
    DATE: 'entry_at',
    OWNER: 'owner_nif',
    ARCHITECTURE_TECNICIAN: 'architecture_technician',
    RESPONSIBLE_TECNICIAN: 'responsible_technician',

    USE: 'use_type',
    PROCEDURE: 'procedure_type',
    CONSTRUCTION: 'construction_type',
    STATUS: 'status',
    FINANCES: 'finances',
    CONSERVATORY: 'conservatory',
});

export const DASHBOARD_ELEMENT = Object.freeze({
    BIGNUMBER: 'big_number',
    LINECHART: 'line_chart',
});